export default {
  // 打车信息
  getCarUrl() {
    return window.$httpUtil.instance.get('api/car/web/check/isAllowUseCar.json')
  },

  // 提示消息
  getNoticeAll() {
    return window.$httpUtil.instance.get('notice/systemNotify.json?notice=0&stop=1')
  },
  orgRangeInit() {
    return window.$httpUtil.instance.get('/api/pp/common/platform/home/orgRangeInit')
  }
}
